module.exports = {
      id: "ic-theme-light-usage",
      viewBox: "0 0 236 180",
      url: __webpack_public_path__ + "sprite-dbc6d5.smartcharts.svg#ic-theme-light-usage",
      toString: function () {
        return this.url;
      }
    }